// Email-shape check for the auth forms. We disable the browser's native
// constraint validation (its bubbles are English / non-localized) and gate on
// this instead, so malformed input gets a single localized error.
//
// Local part (before @): Latin letters/digits plus `. _ + -` only, as
// dot-separated atoms — so no leading/trailing dot and no consecutive dots.
// Domain: ASCII labels (letters/digits/hyphen, not leading/trailing hyphen)
// ending in an alphabetic TLD of 2+ chars.
//
// The pattern is fully anchored and allows no whitespace, and we deliberately do
// NOT trim — so spaces anywhere, including the edges, are rejected rather than
// silently stripped. This keeps non-Latin scripts (Cyrillic/Arabic), stray
// symbols and stray spaces from reaching the sign-up / password step. The
// backend stays the source of truth for stricter rules (deliverability,
// already-registered, etc.).
const EMAIL_RE =
  /^[A-Za-z0-9_+-]+(?:\.[A-Za-z0-9_+-]+)*@(?:[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?\.)+[A-Za-z]{2,}$/;

export function isValidEmail(email: string): boolean {
  return EMAIL_RE.test(email);
}
